import { forwardRef, ReactNode, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { ButtonList, Check, ChildDDL, ChildInfo, Container, DDLSelected, DropItem, DropList, ImageContainer, SelectDDL, Selected } from './GuardianNav.styled';
import DatePicker, { registerLocale } from 'react-datepicker';
import { da } from 'date-fns/locale/da';
import { enGB as en } from 'date-fns/locale/en-GB';
import { useDetectClickOutside } from 'react-detect-click-outside';
import StudentThumbnail from '@components/StudentThumbnail';
import Chevron_Icon from "@assets/svg/chevron-down.svg";
import Calendar_Icon from "@assets/svg/new_calendar.svg";
import Close_Icon from "@assets/svg/match/missing.svg";
import Check_Icon from "@assets/svg/match/attending.svg";
import Modal from '@components/Buttons/Modal';
import { CreateRow, HeadLine, PopCal, PopClose, PopCol, PopContainer, PopRow, PopRowButtons, PopTitle } from '../Guardian.styled';
import DateSelect from '../DateSelect';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import { EnableScroll } from '@utils/scrollController';

registerLocale('da', da);
registerLocale('en-GB', en);


interface IProps {
  student?: any,
  selected?: any,
  setSelected?: (student: any) => void,
  updateStudents?: () => void
}

export const GuardianNav = forwardRef((props: IProps, ref) => {
  const { user, guardianStudents, systemSettings, selectedGuardianStudent, setSelectedGuardianStudent, filterDate, client, settings, setGuardianStudents, groups, whoIsLoggedIn } = useStore();
  const i18n = useI18n();
  const [open, setOpen] = useState(false);
  const [sickModal, setSickModal] = useState(false);
  const [holidayModal, setHolidayModal] = useState(false);
  const [popupState, setPopupState] = useState(1);
  const [requestFailed, setRequestFailed] = useState(null);
  const sickModalRef = useRef(null);
  const holidayModalRef = useRef(null);
  const [fromDate, setFromDate] = useState(new Date())
  const [toDate, setToDate] = useState(new Date())
  const [holidayFromDate, setHolidayFromDate] = useState(new Date())
  const [holidayToDate, setHolidayToDate] = useState(new Date())
  const [timeFrom, setTimeFrom] = useState("08:00")
  const [timeTo, setTimeTo] = useState("09:00")
  const [requests, setRequests] = useState([{ userid: '9', success: true }, { userid: '97414', success: false }])
  const [sickRequestInfo, setSickRequestInfo] = useState(null)
  const [text, setText] = useState('')
  const [selectedPopup, setSelectedPopup] = useState([])
  const [selectOpen, setSelectOpen] = useState(false)
  const closeTimeoutRef = useRef(null)

  useImperativeHandle(ref, () => ({
    handleEditSick(requestInfo) {
      setSickRequestInfo(requestInfo)
      setText(requestInfo.text)
      setFromDate(moment(requestInfo.fromDate).toDate())
      setToDate(moment(requestInfo.toDate).toDate())
      setSickModal(true)
    }
    ,
    handleEditHoliday(requestInfo) {
      // console.log(requestInfo)
      setSickRequestInfo(requestInfo)
      setText(requestInfo.request_text)
      setFromDate(moment(requestInfo.startdatetime).toDate())
      setToDate(moment(requestInfo.enddatetime).toDate())
      setHolidayModal(true)
    }
  }))

  const ClickOutside = () => {
    setOpen(false)
  }
  const outsideRef = useDetectClickOutside({ onTriggered: ClickOutside });

  useEffect(() => {
    setHolidayFromDate(getTomorrowDate())
    setHolidayToDate(getTomorrowDate(true))
  }, [])


  useEffect(() => {
    if (props.selected) setSelectedPopup([props.selected])
  }, [props.selected])

  let studentList = []

  props?.student?.map((s, index) => {
    studentList.push(<DropItem key={"gawf" + index} selected={s?.student_username === props?.selected?.student_username} onClick={() => HandleSelectStudent(s)}>
      <ImageContainer>
        <StudentThumbnail name={s?.student_displayname} src={s?.student_username} />
      </ImageContainer>
      <ChildInfo>
        <span>{s?.student_displayname}</span>
        <span>{s?.absence.secondpercentage}%</span>
      </ChildInfo>
    </DropItem>)
  })

  function HandleSelectStudent(student) {
    props.setSelected(student)
    setSelectedPopup([student])
    setOpen(!open)
  }

  const handleDate = (type, date) => {
    if (type === 1) {
      let t = moment(toDate)
      let d = moment(date)
      setFromDate(date)
      if (t.isBefore(d, 'date')) {
        d = moment(d)
        d.add(1, 'day')
        setToDate(d.toDate())
      }
    }
    else {
      let t = moment(fromDate)
      let d = moment(date)
      setToDate(date)
      if (t.isAfter(d, 'date')) {
        let today = moment()
        d = moment(d)
        if (d.isAfter(today, 'date'))
          d.add(-1, 'day')
        setFromDate(d.toDate())
      }
    }
  }

  const handleHolidayDate = (type, date) => {
    if (type === 1) {
      let t = moment(holidayToDate)
      let d = moment(date)
      setHolidayFromDate(date)
      if (t.isBefore(d, 'date')) {
        d = moment(d)
        d.add(1, 'day')
        setHolidayToDate(d.toDate())
      }
    }
    else {
      let t = moment(holidayFromDate)
      let d = moment(date)
      setHolidayToDate(date)
      if (t.isAfter(d, 'date')) {
        let today = moment()
        d = moment(d)
        if (d.isAfter(today, 'date'))
          d.add(-1, 'day')
        setHolidayFromDate(d.toDate())
      }
    }
  }

  const createSickEvent = async () => {
    setPopupState(2)
    let date = moment(fromDate)
    let todate = moment(toDate)

    let days = []

    if (sickRequestInfo !== null) {
      await db.deleteSickEvent4Student(sickRequestInfo.absence_id)
    }

    let username = user.localAccountId
    // let username = router.pathname === "/guardian" ? "9B6519D4B81620E42D59985CCC6E049E45A1927B2FEA8E17109193E4C3ED8D1FEEDF2ADA699867D2AC5CB312873239E5E119177C3968D42FCF9CFB23CB1D3817" : user.uname
    if (settings.DEMO === "true" || settings.DEMO === true) username = "394236353139443442383136323045343244353939383543434336453034"
    let start: any = fromDate;
    let end: any = toDate;

    start = moment(fromDate).format('YYYY-MM-DD')
    end = moment(toDate).format('YYYY-MM-DD')

    let success = []

    while (date.isSameOrBefore(todate)) {
      days.push(date.format('YYYY-MM-DD'))
      date.add(1, 'day')
    }


    for (let index = 0; index < selectedPopup.length; index++) {
      let student = guardianStudents.find(s => s.student_id === selectedPopup[index].student_id);

      if (student) {
        let timeblocks = []
        for (let i = 0; i < days.length; i++) {
          const d = days[i];
          let sick = await db.Regi_GetCoursesByStudentName(student.student_username, moment(d), settings.USEMERIT, settings.USEPAUSE)
          timeblocks = timeblocks.concat(sick.map(s => { return { reservationId: s.id } }))
        }
        if (timeblocks.length > 0) {
          let tagsToString = "1";
          let result = await db.createLeaveEvent(student.student_id, student.student_username, student.student_id, client.UserName, whoIsLoggedIn.firstname + " " + whoIsLoggedIn.lastname, timeblocks, text, tagsToString, 2, 4)
          success.push({ userid: student.student_id, success: (result && result.length > 0 && result[0].absence_id > 0) })
        }
      }
    }

    setRequests(success)
    props.updateStudents()

    clearTimeout(closeTimeoutRef.current)
    closeTimeoutRef.current = setTimeout(() => {
      handleClose()
    }, 5000)
  }

  const CreateRequest = async () => {
    setPopupState(2)
    let start: any = fromDate;
    let end: any = toDate;
    let username = user.localAccountId
    // let username = router.pathname === "/guardian" ? "9B6519D4B81620E42D59985CCC6E049E45A1927B2FEA8E17109193E4C3ED8D1FEEDF2ADA699867D2AC5CB312873239E5E119177C3968D42FCF9CFB23CB1D3817" : user.uname
    if (settings.DEMO === "true" || settings.DEMO === true) username = "394236353139443442383136323045343244353939383543434336453034"

    start = moment(fromDate).format('YYYY-MM-DD')
    end = moment(toDate).format('YYYY-MM-DD')

    let success = []
    for (let index = 0; index < selectedPopup.length; index++) {
      const student = selectedPopup[index];
      let request = await db.CreateAbsenceRequest(student.student_id, start, end, username, text, 1)
      success.push({ userid: student.student_id, success: (request && request.length > 0 && request[0].result > -1) })
    }
    setRequests(success)
    props.updateStudents()
    clearTimeout(closeTimeoutRef.current)
    closeTimeoutRef.current = setTimeout(() => {
      handleClose()
    }, 5000)
  }

  const handleClose = (type?) => {
    setSickRequestInfo(null)
    setText('')
    setFromDate(new Date())
    setToDate(new Date())
    setSelectedPopup([props.selected])
    setSickModal(false)
    setHolidayModal(false)
    setPopupState(1)
    setRequests([])
    EnableScroll()
    sickModalRef?.current?.handleClose()
    holidayModalRef?.current?.handleClose()
  }

  const UpdateRequest = async () => {
    let username = user.localAccountId
    if (settings.DEMO === "true" || settings.DEMO === true) username = "394236353139443442383136323045343244353939383543434336453034"
    let result = await db.UpdateAbsenceRequest(sickRequestInfo.request_id, username, moment(fromDate).format('YYYY-MM-DD'), moment(toDate).format('YYYY-MM-DD'), text, 1)
    props.updateStudents()
    handleClose()
  }

  const handleTextInput = (e) => {
    setText(e.target.value)
  }

  const HandlePopupSelect = (student, type) => {
    if (type === 1) {
      let temp = JSON.parse(JSON.stringify(selectedPopup));

      if (selectedPopup?.some(s => s.student_username == student.student_username)) {
        temp = temp.filter(s => s.student_username != student.student_username)
      } else {
        temp.push(student)
      }

      setSelectedPopup(temp)
    } else {
      if (guardianStudents?.length === selectedPopup?.length) {
        setSelectedPopup([])
      } else {
        setSelectedPopup(guardianStudents)
      }
    }
  }

  const ClickOutsideDDL = () => {
    setSelectOpen(false)
  }
  const ddlRef = useDetectClickOutside({ onTriggered: ClickOutsideDDL });

  const getTomorrowDate = (to?) => {
    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + (to? 2: 1))
    return tomorrow
  }
  

  return (<>
    {sickModal ? <Modal clickOutside={true} ref={sickModalRef} onClose={handleClose} backColor='rgba(0,0,0,0.25)' stickBottom={true}>
      {popupState === 1 ? <PopContainer>
        <PopTitle>{i18n.t("report-sick-create")}</PopTitle>
        <PopClose onClick={() => handleClose(1)}><Close_Icon /></PopClose>
        <HeadLine />
        <PopRow ref={ddlRef}>
          <span>{i18n.t("guardian-select-child")}</span>
          <SelectDDL>
            <DDLSelected disable={sickRequestInfo !== null} open={selectOpen} onClick={() => sickRequestInfo ? null : setSelectOpen(!selectOpen)}>
              {
                selectedPopup?.length > 1 ? i18n.t("ddl-more") : selectedPopup?.length === 0 || selectedPopup === null ? i18n.t("guardian-select-child") : selectedPopup[0]?.student_displayname
              }
              <Chevron_Icon />
            </DDLSelected>
            <DropList open={selectOpen}>
              {props?.student?.map((s, index) => {
                return <div key={"wra" + index} className='flexy' onClick={() => HandlePopupSelect(s, 1)}><Check checked={selectedPopup !== null ? selectedPopup?.some(st => st.student_username == s?.student_username) : false}><Check_Icon /></Check> {s?.student_displayname}</div>
              })}
              <div className='flexy' onClick={() => HandlePopupSelect(null, 2)}><Check checked={false}><Check_Icon /></Check>{i18n.t(guardianStudents?.length === selectedPopup?.length ? "unmark-all" : "select-all")}</div>
            </DropList>
          </SelectDDL>
        </PopRow>
        <PopRow col={true}>
          <PopCol>
            <span>{i18n.t("export-from")}</span>
            <DateSelect type={1} value={fromDate} setDate={handleDate}>
              <PopCal>{moment(fromDate).format("DD-MM-YYYY")}<Calendar_Icon /></PopCal>
            </DateSelect>
          </PopCol>
          <PopCol>
            <span>{i18n.t("export-to")}</span>
            <DateSelect type={2} value={toDate} setDate={handleDate}>
              <PopCal>{moment(toDate).format("DD-MM-YYYY")}<Calendar_Icon /></PopCal>
            </DateSelect>
          </PopCol>
        </PopRow>
        <PopRow>
          <span>{i18n.t("guardian-holiday-remarks") + " (" + i18n.t("guardian-optional") + ")"}</span>
          <textarea value={text} onChange={handleTextInput} placeholder={i18n.t("guardian-remarks-placeholder") + "..."} />
        </PopRow>
        <PopRowButtons>
          <button onClick={() => handleClose()}>{i18n.t("cancel")}</button>
          <button onClick={() => createSickEvent()}>{i18n.t("confirm")}</button>
        </PopRowButtons>
      </PopContainer> : <PopContainer>
        <PopTitle>{i18n.t("report-sick-create")}</PopTitle>
        <HeadLine />
        {requests.map((r, index) => {
          let student = guardianStudents.find(s => s.student_id === r.userid)
          return <PopRow key={"request" + index}>
            <CreateRow>
              <ImageContainer>
                <StudentThumbnail name={student?.student_displayname} src={student?.student_username} />
              </ImageContainer>
              <span>{student?.student_displayname}</span>
              {r.success ? <Check_Icon style={{ color: "green" }} /> : <Close_Icon style={{ color: "red" }} />}
            </CreateRow>
          </PopRow>
        })}
      </PopContainer>}
    </Modal> : null}

    {holidayModal ? <Modal clickOutside={true} ref={holidayModalRef} onClose={handleClose} backColor='rgba(0,0,0,0.25)' stickBottom={true}>
      {popupState === 1 ? <PopContainer>
        <PopTitle>{i18n.t("guardian-request-free")}</PopTitle>
        <PopClose onClick={() => handleClose(2)}><Close_Icon /></PopClose>
        <HeadLine />
        <PopRow ref={ddlRef}>
          <span>{i18n.t("guardian-select-child")}</span>
          <SelectDDL>
            <DDLSelected open={selectOpen} onClick={() => setSelectOpen(!selectOpen)}>
              {selectedPopup?.length > 1 ? i18n.t("ddl-more") : selectedPopup?.length < 1 ? i18n.t("guardian-select-child") : selectedPopup[0]?.student_displayname}
              <Chevron_Icon />
            </DDLSelected>
            <DropList open={selectOpen}>
              {props?.student?.map((s, index) => {
                return <div key={"wra" + index} className='flexy' onClick={() => HandlePopupSelect(s, 1)}><Check checked={selectedPopup?.some(st => st.student_username == s.student_username)}><Check_Icon /></Check> {s?.student_displayname}</div>
              })}
              <div className='flexy' onClick={() => HandlePopupSelect(null, 2)}><Check checked={false}><Check_Icon /></Check>{i18n.t(guardianStudents?.length === selectedPopup?.length ? "unmark-all" : "select-all")}</div>
            </DropList>
          </SelectDDL>
        </PopRow>
        <PopRow col={true}>
          <PopCol>
            <span>{i18n.t("export-from")}</span>
            <DateSelect minDate={getTomorrowDate()} type={1} value={holidayFromDate} setDate={handleHolidayDate}>
              <PopCal>{moment(holidayFromDate).format("DD-MM-YYYY")}<Calendar_Icon /></PopCal>
            </DateSelect>
          </PopCol>
          <PopCol>
            <span>{i18n.t("export-to")}</span>
            <DateSelect minDate={getTomorrowDate(true)} type={2} value={holidayToDate} setDate={handleHolidayDate}>
              <PopCal>{moment(holidayToDate).format("DD-MM-YYYY")}<Calendar_Icon /></PopCal>
            </DateSelect>
          </PopCol>
        </PopRow>
        <PopRow>
          <span>{i18n.t("guardian-holiday-remarks") + " (" + i18n.t("guardian-optional") + ")"}</span>
          <textarea value={text} onChange={handleTextInput} placeholder={i18n.t("guardian-remarks-placeholder") + "..."} />
        </PopRow>
        <PopRowButtons>
          <button onClick={() => handleClose(2)}>{i18n.t("cancel")}</button>
          <button onClick={() => sickRequestInfo ? UpdateRequest() : CreateRequest()}>{i18n.t("guardian-send-request")}</button>
        </PopRowButtons>
      </PopContainer> : <PopContainer>
        <PopTitle>{i18n.t("guardian-request-free")}</PopTitle>
        <HeadLine />
        {requests.map((r, index) => {
          // @ts-ignore
          let student = guardianStudents.find(s => s.student_id === r.userid)
          console.log(student)
          return <PopRow key={"request" + index}>
            <CreateRow>
              <ImageContainer>
                <StudentThumbnail name={student?.student_displayname} src={student?.student_username} />
              </ImageContainer>
              <span>{student?.student_displayname}</span>
              {r.success ? <Check_Icon style={{ color: "green" }} /> : <Close_Icon style={{ color: "red" }} />}
            </CreateRow>
          </PopRow>
        })}
      </PopContainer>}
    </Modal> : null}


    <Container>
      <div>
        <ChildDDL ref={outsideRef}>
          <Selected selected={true} open={open} onClick={() => setOpen(!open)}>
            <ImageContainer>
              <StudentThumbnail name={props?.selected?.student_displayname} src={props?.selected?.student_username} />
            </ImageContainer>
            <ChildInfo>
              <span>{props?.selected?.student_displayname}</span>
              <span>{props?.selected?.absence.secondpercentage}%</span>
            </ChildInfo>
            <Chevron_Icon />
          </Selected>
          <DropList open={open}>
            {studentList}
          </DropList>
        </ChildDDL>

        <ButtonList>
          <button onClick={() => setSickModal(true)}>+ {i18n.t("guardian-report-sick")}</button>
          <button onClick={() => setHolidayModal(true)}>+ {i18n.t("guardian-request-absence")}</button>
        </ButtonList>
      </div>
    </Container>
  </>);
});

export default GuardianNav;
